import React, { useEffect, useState } from "react";
import {ReactComponent as PagingNext} from 'src/assets/pagingNext.svg';
import {ReactComponent as PagingPre} from 'src/assets/pagingPre.svg';

interface PaginationProps {
    totalPages: number;  // totalPages 타입 명시
    currentPage: number; // currentPage 타입 명시
    onPageChange: (page: number) => void; // onPageChange 함수 타입 명시
    type?: 'book' | 'postcard' | 'author' | 'mypageBook' | 'mypagePostcard';

}

const Paging: React.FC<PaginationProps> = ({ totalPages, currentPage, onPageChange }) => {
    const [visiblePages, setVisiblePages] = useState<number[]>([]);

    useEffect(() => {
        const getVisiblePages = (page: number, total: number): number[] => {
            if (total <= 5) {
                return [...Array(total)].map((_, idx) => idx + 1);
            }
            if (page <= 3) {
                return [1, 2, 3, 4, 5];
            }
            if (page >= total - 2) {
                return [total - 4, total - 3, total - 2, total - 1, total];
            }
            return [page - 2, page - 1, page, page + 1, page + 2];
        };

        setVisiblePages(getVisiblePages(currentPage, totalPages));
    }, [currentPage, totalPages]);

    return (
        <div className="flex gap-1  justify-center">
            <button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className="px-1  rounded"
            >
                <PagingPre/>
            </button>

            {visiblePages.map((page) => (
                <button
                    key={page}
                    onClick={() => onPageChange(page)}
                    className={`px-3  ${
                        currentPage === page ? "text-main font-bold text-sm" : "text-black text-sm font-normal"
                    } rounded`}
                >
                    {page}
                </button>
            ))}

            <button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="px-1  rounded"
            >
                <PagingNext/>
            </button>
        </div>
    );
};

export default Paging;
